import type { DiagnosticReport } from '@entities/assessment'

import { DiagnosticReportType } from '@entities/assessment'

const configDiagnosticReportStrengths: DiagnosticReport = {
  id: DiagnosticReportType.Strengths,
  title: 'Strengths',
}

const configDiagnosticReportImprovements: DiagnosticReport = {
  id: DiagnosticReportType.Improvements,
  title: 'Areas of improvement',
}

export const configDiagnosticReports: DiagnosticReport[] = [
  configDiagnosticReportStrengths,
  configDiagnosticReportImprovements,
]
